import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "@santander/security-angular";
import { ROUTE_PATH } from "../../environments/environment";
import { LayoutService } from "./layout.service";
import { UserService } from "./user.service";
import { LoginService } from "./login.service";
import { DataService } from "./data.service";

@Injectable({
  providedIn: "root",
})
export class PrescriptorRoutingService {
  private acceso = false;

  constructor(
    private readonly router: Router,
    private readonly layoutService: LayoutService,
    private readonly userService: UserService,
    private readonly loginService: LoginService,
    private readonly dataService: DataService,
    private readonly oauthService: OAuthService
  ) {}

  /**
   * Fetches prescriptor data and navigates to the correct route
   * based on actuacion and subtipo.
   */
  getDatosPrescriptorAndNavigate(): void {
    let nombre = "";
    let contrato = "";
    let nUser = "";
    let actuacion = "";
    let subtipoPrescriptor = "";
    let telefono = "";
    let email = "";
    let emailOficina = "";
    let telefonoOficina = "";

    this.userService.getContactData().subscribe(
      async (response: any) => {
        const empresa = response.methodResult.contrato.CENTRO.EMPRESA;
        const centro = response.methodResult.contrato.CENTRO.CENTRO;
        const producto = response.methodResult.contrato.PRODUCTO;
        const numContrato = response.methodResult.contrato.NUMERO_DE_CONTRATO;
        const oficina = response.methodResult.descOficina;
        const oficinaMapfre = response.methodResult.descOfiMp;
        const claveMp = response.methodResult.codPrescMp;
        const oficinaM =
          response.methodResult.codOfiMp + " " + response.methodResult.nomOfiMp;

        const subtipo = response.methodResult.codSubtipoPresc;
        const uid = response.methodResult.uid;
        const docInicial = uid;

        actuacion = response.methodResult.actuacion;
        subtipoPrescriptor = response.methodResult.codSubtipoPresc;
        contrato = centro + " " + oficina;
        nombre = response.methodResult.nombre;
        nUser = response.methodResult.nombre;
        telefono = response.methodResult.telefono;
        email = response.methodResult.email;
        response.methodResult.emailOficina
          ? (emailOficina = response.methodResult.emailOficina)
          : (emailOficina = "");
        response.methodResult.telfOficina
          ? (telefonoOficina = response.methodResult.telfOficina)
          : (telefonoOficina = "");

        sessionStorage.setItem("nUser", nUser);
        sessionStorage.setItem("action", actuacion);
        sessionStorage.setItem("nombreHader", nombre);
        sessionStorage.setItem("contratoHeader", contrato);
        sessionStorage.setItem("telefono", telefono);
        sessionStorage.setItem("email", email);
        sessionStorage.setItem("doc", uid);
        sessionStorage.setItem("oficina", oficina);
        sessionStorage.setItem("oficinaMapfre", oficinaMapfre);
        sessionStorage.setItem("claveMp", claveMp);
        sessionStorage.setItem("oficinaM", oficinaM);
        sessionStorage.setItem("empresaPresc", empresa);
        sessionStorage.setItem("centroPresc", centro);
        sessionStorage.setItem("productoPresc", producto);
        sessionStorage.setItem("numContratoPresc", numContrato);
        sessionStorage.setItem("subtipoPresc", subtipo);
        sessionStorage.setItem("emailOfi", emailOficina);
        sessionStorage.setItem("telfOfi", telefonoOficina);
        sessionStorage.setItem("uid", uid);
        sessionStorage.setItem(
          "codPers",
          response.methodResult.cliente.TIPO_DE_PERSONA +
            response.methodResult.cliente.CODIGO_DE_PERSONA
        );
        sessionStorage.removeItem("tipoPresc");

        if (docInicial && !docInicial.includes("@")) {
          await this.getPrescriberProfile(docInicial);
        } else {
          this.acceso = true;
        }

        if (this.acceso) {
          this.getOficinas();
        }

        if (actuacion === "19" || actuacion === "20" || actuacion === "21") {
          sessionStorage.setItem("tipoPresc", "mapfre");
          this.router.navigateByUrl(ROUTE_PATH.inicioProductos);
          this.layoutService.hideResetPass();
          this.layoutService.showFooter();
        }
        if (
          (actuacion === "16" || actuacion === "99") &&
          subtipoPrescriptor === "004"
        ) {
          this.checkPrescComLogin();
        }
        if (subtipoPrescriptor === "011") {
          this.checkPrescBPLogin();
        }
        if (subtipoPrescriptor === "019") {
          this.checkPrescULogin();
        }
        if (subtipoPrescriptor === "015") {
          this.checkPrescRALogin();
        }
        if (subtipoPrescriptor === "018") {
          this.checkPrescDLogin();
        }
      },
      () => {
        // this.router.navigateByUrl(ROUTE_PATH.login);
      }
    );
  }

  private getPrescriberProfile(uid: string): Promise<any> {
    this.acceso = false;

    return new Promise((resolve, rejects) => {
      this.loginService.getProfile(uid).subscribe(
        (response: any) => {
          const responseProfile = response;
          if (
            responseProfile.tipoControlProduc &&
            responseProfile.tipoControlProduc.trim() === "1"
          ) {
            responseProfile.tipoControlUid.forEach((uidCode: any) => {
              if (uidCode.trim() === "2") {
                this.acceso = true;
              }
            });
          } else {
            this.acceso = true;
          }
          resolve(responseProfile);
        },
        (err) => {
          this.acceso = false;
          rejects(err);
        }
      );
    });
  }

  private getOficinas(): void {
    this.loginService.getOficinas().subscribe(
      (response) => {
        const oficinas = response.response;
        const oficinasParse = JSON.stringify(oficinas);
        this.loginService.setStorageOficinas(oficinasParse);
      },
      () => {}
    );
  }

  private checkPrescComLogin(): void {
    if (this.acceso) {
      sessionStorage.setItem("tipoPresc", "comercial");
      this.router.navigateByUrl(ROUTE_PATH.inicioProductos);
      this.layoutService.hideResetPass();
      this.layoutService.hideFooter();
    } else {
      this.router.navigateByUrl(ROUTE_PATH.inicioPcomerciales);
      this.dataService.setBackground("sinfondo");
      this.layoutService.hideResetPass();
    }
  }

  private checkPrescBPLogin(): void {
    if (this.acceso) {
      sessionStorage.setItem("tipoPresc", "privada");
      this.router.navigateByUrl(ROUTE_PATH.inicioProductos);
      this.layoutService.hideResetPass();
      this.layoutService.hideFooter();
    } else {
      this.layoutService.hideFooter();
      Promise.resolve((this.oauthService as any).logout()).finally(() => {
        sessionStorage.clear();
        this.router.navigate([ROUTE_PATH.initCallback]);
      });
    }
  }

  private checkPrescRALogin(): void {
    if (this.acceso) {
      sessionStorage.setItem("tipoPresc", "rentingAuto");
      this.router.navigateByUrl(ROUTE_PATH.inicioProductos);
      this.layoutService.hideResetPass();
      this.layoutService.hideFooter();
    } else {
      this.layoutService.hideFooter();
      Promise.resolve((this.oauthService as any).logout()).finally(() => {
        sessionStorage.clear();
        this.router.navigate([ROUTE_PATH.initCallback]);
      });
    }
  }

  private checkPrescULogin(): void {
    if (this.acceso) {
      sessionStorage.setItem("tipoPresc", "universidades");
      this.router.navigateByUrl(ROUTE_PATH.inicioProductos);
      this.layoutService.hideResetPass();
      this.layoutService.hideFooter();
    } else {
      this.layoutService.hideFooter();
      Promise.resolve((this.oauthService as any).logout()).finally(() => {
        sessionStorage.clear();
        this.router.navigate([ROUTE_PATH.initCallback]);
      });
    }
  }

  private checkPrescDLogin(): void {
    if (this.acceso) {
      sessionStorage.setItem("tipoPresc", "digital");
      this.router.navigateByUrl(ROUTE_PATH.inicioProductos);
      this.layoutService.hideResetPass();
      this.layoutService.hideFooter();
    } else {
      this.layoutService.hideFooter();
      Promise.resolve((this.oauthService as any).logout()).finally(() => {
        sessionStorage.clear();
        this.router.navigate([ROUTE_PATH.initCallback]);
      });
    }
  }
}
